import $ from 'jquery';
import 'slick-carousel';

function slickMain() {
  /*var elem = $('#slick-main').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      speed: 2000,
      arrows: false,
      autoplay: true,
      infinite:true,
      pauseOnHover: false,
      fade:true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }*/
}


var init = function () {
  slickMain();
}

var tresize = function(){
  slickMain();
}

$(window).on('load', function () {
  init();
});

$(window).on('resize', function () {
  tresize();
});
